module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a4A7X"))).then(() => parcelRequire('1iHdE'));